import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { PaymentTermsServiceProxy, CreateOrEditPaymentTermDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    selector: 'createOrEditPaymentTermModal',
    templateUrl: './create-or-edit-paymentTerm-modal.component.html',
    standalone: false,
})
export class CreateOrEditPaymentTermModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    paymentTerm: CreateOrEditPaymentTermDto = new CreateOrEditPaymentTermDto();

    constructor(
        injector: Injector,
        private _paymentTermsServiceProxy: PaymentTermsServiceProxy,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(paymentTermId?: number): void {
        if (!paymentTermId) {
            this.paymentTerm = new CreateOrEditPaymentTermDto();
            this.paymentTerm.id = paymentTermId;

            this.active = true;
            this.modal.show();
        } else {
            this._paymentTermsServiceProxy.getPaymentTermForEdit(paymentTermId).subscribe((result) => {
                this.paymentTerm = result.paymentTerm;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;

        this._paymentTermsServiceProxy
            .createOrEdit(this.paymentTerm)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
